/**
 * Utilitários para o componente Flow
 * Mantém a mesma lógica original para preservar funcionalidade
 */

/**
 * Extrai parâmetros da URL
 */
export const extractUrlParameters = (params, location) => {
  const urlParams = new URLSearchParams(location.search);
  const id = params.id || urlParams.get("id");
  const action = params.action || urlParams.get("action");
  return { id, action };
};

/**
 * Obtém o título da página baseado na ação
 */
export const getPageTitle = (action, intl) => {
  return action === "edit"
    ? intl.formatMessage({ id: "EDIT_FLOW" })
    : intl.formatMessage({ id: "NEW_FLOW" });
};

/**
 * Faz match de produto por code com lista de produtos do ecommerce
 */
export const matchProductByCode = (productCode, ecommerceProducts) => {
  if (!ecommerceProducts?.length) return null;
  return ecommerceProducts.find((product) => product.value === productCode);
};

/**
 * Transforma documentos da API para formato do formulário
 */
export const transformDocuments = (docs, ecommerceProducts = []) =>
  docs.map((doc) => ({
    ...doc,
    documentConfigId: doc.id || doc.documentConfigId,
    fileNameTranslations: doc.fileNameTranslations || {},
    allowedFileTypes: Array.isArray(doc.fileTypes)
      ? doc.fileTypes.map((type) => ({ value: type, label: type }))
      : [],
    productsEcommerce: Array.isArray(doc.products)
      ? doc.products.map((prod) => {
          const matchedProduct = matchProductByCode(
            prod.code,
            ecommerceProducts
          );
          return (
            matchedProduct || {
              value: prod.code,
              label: String(prod.productName),
            }
          );
        })
      : [],
  }));

/**
 * Transforma tipos da API para formato do formulário
 */
export const transformTypes = (types) =>
  Array.isArray(types)
    ? types.map((type) => ({ value: type, label: type }))
    : [];

/**
 * Obtém erro de campos aninhados
 */
export const getNestedError = (name, formState) => {
  const keys = name.split(".");
  let error = formState.errors;

  for (const key of keys) {
    if (error && error[key]) {
      error = error[key];
    } else {
      return null;
    }
  }

  return error;
};

/**
 * Códigos de sucesso para operações
 */
export const SUCCESS_CODES = {
  CREATE: [200, 201, 45000],
  EDIT: [200, 201, 45001],
  DELETE: [200, 201, 45002],
};

/**
 * Opções de formato de arquivo
 */
export const formatOptions = [
  { value: "PDF", label: "PDF" },
  { value: "XLSX", label: "XLSX" },
  { value: "JPG", label: "JPG" },
  { value: "JPEG", label: "JPEG" },
  { value: "PNG", label: "PNG" },
];
